import { BODY_FONT, splitLines, wrapText } from '../text.utils'
import type { TicketElement } from '../TicketElement'

export class Box implements TicketElement {
  padding: number
  marginTop: number
  titleMarginBottom: number
  lineHeight: number
  title: string
  content?: string

  constructor(title: string, content?: string) {
    this.padding = 10
    this.marginTop = 20
    this.titleMarginBottom = 5
    this.lineHeight = 22
    this.title = title?.toUpperCase()
    this.content = content
  }

  height(ctx: CanvasRenderingContext2D, width: number): number {
    if (!this.title && !this.content) return 0
    ctx.font = `bold 16px ${BODY_FONT}`
    ctx.textAlign = 'left'
    const messageWidth = width - this.padding
    const lines = splitLines(ctx, this.title, messageWidth).length
    ctx.font = `16px ${BODY_FONT}`
    const contentLines = splitLines(ctx, this.content, messageWidth).length
    return (
      this.marginTop +
      this.titleMarginBottom +
      this.padding * 2 +
      this.lineHeight * (lines + contentLines)
    )
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    ctx.fillStyle = 'black'
    ctx.font = `bold 16px ${BODY_FONT}`
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    top += this.marginTop
    const messageWidth = width - this.padding * 2
    const height =
      wrapText(ctx, this.title, width / 2, top + this.padding + this.lineHeight / 2, messageWidth) *
      this.lineHeight
    ctx.font = `14px ${BODY_FONT}`
    const contentHeight =
      wrapText(
        ctx,
        this.content,
        width / 2,
        top + height + this.titleMarginBottom + this.padding + this.lineHeight / 2,
        messageWidth
      ) * this.lineHeight
    ctx.strokeRect(
      0,
      top,
      width,
      height + contentHeight + this.titleMarginBottom + this.padding * 2
    )
  }
}
